/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

export const config = {
	Auth: {
		identityPoolId: import.meta.env.VITE_COGNITO_IDP_ID,

		region: 'us-east-1',

		identityPoolRegion: 'us-east-1',

		userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,

		userPoolWebClientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID,

		mandatorySignIn: false,

		authenticationFlowType: 'CUSTOM_AUTH',
	},
};
